import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/icons/nft-info.svg'
import _imports_1 from '@/assets/images/icons/close_24.svg'


const _hoisted_1 = { class: "nft-card-info-comp" }
const _hoisted_2 = {
  key: 0,
  class: "nft-card-info-header"
}
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = { class: "header-close" }
const _hoisted_5 = { class: "nft-card-info-item-list" }
const _hoisted_6 = { class: "nft-card-info-item-section" }
const _hoisted_7 = { class: "nft-card-info-item" }
const _hoisted_8 = { class: "nft-card-info-title mb-12" }
const _hoisted_9 = { class: "nft-card-info-content" }
const _hoisted_10 = { class: "nft-card-info-item-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MvPageTab = _resolveComponent("MvPageTab")!
  const _component_NftCardQtnrInfoComp = _resolveComponent("NftCardQtnrInfoComp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t("nftCard.precautionTitle")), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _imports_1,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSlide && _ctx.closeSlide(...args)))
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isQtnr)
      ? (_openBlock(), _createBlock(_component_MvPageTab, {
          key: 1,
          selected: _ctx.selectedInfo,
          "onUpdate:selected": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedInfo) = $event)),
          tabs: [
                {
                  name: 'nftCard.precaution.tabs.nft',
                  value: 'nft',
                },
                {
                  name: 'nftCard.precaution.tabs.attendee',
                  value: 'attendee',
                },
            ],
          class: "mb-16"
        }, null, 8, ["selected"]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("nftCard.precaution.considerations.title")), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, _toDisplayString(_ctx.data.memo ? _ctx.data.memo : _ctx.$t("nftCard.precaution.considerations.empty")), 1)
          ])
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.isQtnr || _ctx.selectedInfo === 'nft']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _createVNode(_component_NftCardQtnrInfoComp, {
        "qtnr-info": _ctx.data.qtnrInfo,
        "qtnr-template": _ctx.data.qtnrTemplate
      }, null, 8, ["qtnr-info", "qtnr-template"])
    ], 512), [
      [_vShow, _ctx.selectedInfo === 'attendee']
    ])
  ]))
}